var exports = {
  "k": "xe7b6e3d6--e00940--container",
  "K": "xe7b6e3d6--e00940--icon",
};

module.exports = exports;
